import React, {useState, useEffect} from 'react';

import styles from '@styles/common/Letter.module.scss';
import {charaters} from '@utils/charaters';

const wrapperRef = React.createRef();
const MobileLetter = props => {
	const {data, activeFilter, callBack, charater} = props;
	const [state, setState] = useState({
		showList: false,
		charSelected: false,
	});

	const selectChartater = char => {
		if (!data || data[char] || char === 'All') {
			if (callBack) callBack(char);
			setState(preState => ({
				...preState,
				showList: false,
				charSelected: true,
			}));
		}
	};
	useEffect(() => {
		const outSideModalClickEvent = () => {
			if (wrapperRef && !wrapperRef.current?.contains(event.target)) {
				setState(preState => ({
					...preState,
					showList: false,
				}));
			}
		};

		const removeListener = () => {
			document.removeEventListener('mousedown', outSideModalClickEvent);
		};
		document.addEventListener('mousedown', outSideModalClickEvent);
		return () => {
			removeListener();
		};
	}, []);

	return (
		<div className={`${styles.mobileLetterSection}`}>
			<div
				className={styles.outerSelected}
				onClick={() => {
					setState(preState => ({
						...preState,
						showList: !state.showList,
					}));
				}}
			>
				<p className={styles.center}>
					{!state.charSelected ? 'Filter by letter' : charater}
				</p>
				<i className='fas fa-chevron-down'></i>
			</div>
			{state.showList && (
				<div className={styles.lists} ref={wrapperRef}>
					<div className={`${styles.item} ${styles.disable}`}>
						{!state.charSelected && <i className='fas fa-check'></i>}
						<span>Filter by letter</span>
					</div>
					{charaters.map(char => {
						if (char !== 'All' || (activeFilter && char === 'All'))
							return (
								<div
									id={`link-item-${char}`}
									className={`${styles.item} ${
										data
											? !data[char] && char !== 'All'
												? styles.disable
												: ''
											: ''
									}`}
									key={char}
									onClick={() => selectChartater(char)}
								>
									{charater === char && state.charSelected && (
										<i className='fas fa-check'></i>
									)}
									<span>{char}</span>
								</div>
							);
					})}
				</div>
			)}
		</div>
	);
};

export default MobileLetter;
